import '../MyTeams/CreateTeam.css'
import '../GameRoom/GRStyle.css'
import PropTypes from 'prop-types'
import { logoMap } from '../data-maps/club-logo-map'
import trophyIcon from '../assets/Trophy.png'
import coinIcon from '../assets/wallet_coins.png'
import ShareActionDropdown from '../Component/ShareActionDropdown'
import { useUser } from '../UserContext'
import { getGameRoomTimeDetails } from '../utils/getGameRoomTimeDetails'
import { getTeamsData } from './gameRoomUtils'
import UseCountdownTimer from '../Component/UseCountdownTimer'
import { formatCountdownTime } from '../utils/formatCountdownTime'
import { HeadToHeadValueString } from '../constants'
import useJoinPopupsTrigger from './hooks/useJoinPopupsTrigger'
import { getNetworkLogo } from '../utils/networkUtils'

export default function GameRoomsCard(props) {
  const { user } = useUser()

  const grDetails = props.GRDetails
  const prizePool = grDetails?.prizePool
  const { firstTeam, secondTeam } = getTeamsData(grDetails)

  // counter =====================
  const { roomStatus, targetTime } = getGameRoomTimeDetails({
    entryOpenTime: grDetails?.startDate,
    entryCloseTime: grDetails?.endDate,
    gameStartTime: grDetails?.gameRoomActionStartDate,
    gameEndTime: grDetails?.gameRoomActionEndDate,
  })

  const timeLeft = UseCountdownTimer(targetTime)

  const handleJoin = useJoinPopupsTrigger()

  return (
    <>
      {props?.isError ? <p>{props.error.message} </p> : ''}
      {/* main card  */}
      <div
        className={`GR-Card abstract-bg ${grDetails?.brand?.theme?.identity ? `card-color-${grDetails?.brand?.theme?.identity}` : ''}`}
      >
        {/* share btn for GR details screen's hero section  */}
        {props.isGR_heroSection && (
          <ShareActionDropdown
            grDetails={grDetails}
            buttonType='icon'
            customStyles={{ zIndex: 40 }}
          />
        )}

        {/* row 1  */}
        <div className='flex-row' style={{ marginBottom: '20px' }}>
          {/* game room name section =========== */}
          <div className='gm-name-section u-capitalize'>
            <p style={{ color: 'skyblue' }}>{grDetails?.league?.name ?? ''}</p>
            <h2> {grDetails?.name} </h2>
          </div>
          {/* GR logo section  */}
          <div className='flex-row' style={{ gap: '10px' }}>
            {grDetails?.type === HeadToHeadValueString ? (
              <>
                <div className='TeamLogoContainer'>
                  <img
                    src={logoMap[firstTeam?.identity] || firstTeam?.image_path}
                    alt='team 1'
                    className='teamIconImg'
                  />
                </div>
                <p>vs</p>
                <div className='TeamLogoContainer'>
                  <img
                    src={
                      logoMap[secondTeam?.identity] || secondTeam?.image_path
                    }
                    alt='team 2'
                    className='teamIconImg'
                  />
                </div>
              </>
            ) : (
              <div>
                <img
                  src={grDetails?.league?.logo ?? ''}
                  alt={grDetails?.league?.name ?? ''}
                  className='teamIconImg'
                />
              </div>
            )}
          </div>
        </div>
        {/* row 2 */}
        <div className='flex-row'>
          {/* prize section  */}
          <div className='gr-prize-section'>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <img src={trophyIcon} alt='Prize' />
              <div>
                <p style={{ fontSize: '0.7rem', color: 'skyblue' }}>
                  Prize Pool
                </p>
                <h3>{prizePool}</h3>
                <p>
                  <small>{grDetails?.token}</small>
                </p>
              </div>
            </div>
          </div>

          {/* join btn section  */}
          <div className='join-btn-area'>
            <div className='btn-second'>
              {/* entree fees */}
              <div className='gr-fees-section'>
                <img src={coinIcon} alt='fees' />
                <div>
                  <p>
                    <small>Entry fee</small>
                  </p>
                  {grDetails?.entryFee === '0' ? (
                    <p> Free </p>
                  ) : (
                    <h3>
                      {grDetails?.entryFee} &nbsp;
                      <small>{grDetails?.token}</small>
                    </h3>
                  )}
                </div>
              </div>

              {/* btn text , roomStatus is based on countdown timer   ========*/}
              <p
                className='btn-border'
                onClick={props.isGR_heroSection ? handleJoin : undefined}
              >
                {roomStatus === 'upComing' && 'upcoming '}
                {roomStatus === 'entryOpened' && 'enter'}
                {roomStatus === 'entryClosed' && 'closed'}
                {roomStatus === 'live' && 'live'}
                {roomStatus === 'closed' && 'closed'}
                {!props.isGR_heroSection && (
                  <i
                    className='bi bi-chevron-compact-right'
                    style={{ fontSize: '0.8rem', marginLeft: '10px' }}
                  ></i>
                )}
              </p>
            </div>
            {/* timer section  */}
            {roomStatus !== 'closed' && (
              <div className='countdownTimer '>
                {roomStatus === 'upComing' && <p>opening in: </p>}
                {roomStatus === 'entryOpened' && <p>closing in: </p>}
                {roomStatus === 'live' && <p>game end in: </p>}
                {roomStatus !== 'closed' && timeLeft && (
                  <p style={{ color: 'white' }}>
                    {formatCountdownTime(timeLeft)}
                  </p>
                )}
              </div>
            )}
          </div>
        </div>

        {/* hasJoined */}
        {user.token && props.hasJoined && (
          <div className='status hasJoined'>Joined</div>
        )}
        {/* streak status  */}
        {user.token && props.streakStatus && (
          <div className={`status ${props.streakStatus}`}>
            {props.streakStatus.charAt(0).toUpperCase() +
              props.streakStatus.slice(1)}
          </div>
        )}

        {/* brand section */}
        {grDetails?.brand && (
          <div className='gr-card-brand'>
            {grDetails.brand.logoUrl && (
              <img
                src={grDetails.brand.logoUrl}
                alt='brand-logo'
                className='gr-brand-logo'
              />
            )}
            <span className='gr-brand-name'>{grDetails.brand.name}</span>
          </div>
        )}

        {/* network icon  */}
        <img className='NetworkIcon' src={getNetworkLogo(grDetails?.network)} />
      </div>
    </>
  )
}

GameRoomsCard.propTypes = {
  GRDetails: PropTypes.object.isRequired,
  isError: PropTypes.bool,
  error: PropTypes.any,
  isGR_heroSection: PropTypes.bool,
  hasJoined: PropTypes.bool,
  streakStatus: PropTypes.string,
}
